import {
  BALANCE_CHANGES,
  NOTIFICATION_TYPE,
} from '@/modules/notification/types';
import { RootStore } from '@/store';
import { makeAutoObservable, reaction } from 'mobx';

export class NotificationStore {
  readonly rootStore: RootStore;
  public notificationType: NOTIFICATION_TYPE | null = null;

  public balanceChanges: { tokens: number; usd: number } = {
    tokens: 0,
    usd: 0,
  };
  public notificationMessage: string = '';

  constructor({ rootStore }: { rootStore: RootStore }) {
    this.rootStore = rootStore;
    makeAutoObservable(this, {}, { autoBind: true });
    reaction(
      () => this.rootStore.accountStore.accountData.tokens,
      (value, prevValue) => {
        if (value > prevValue) {
          this.setNotificationType(NOTIFICATION_TYPE.BALANCE_CHANGES);
          this.setBalanceChange({
            ...this.balanceChanges,
            tokens: value - prevValue,
          });
        }
      },
    );
    reaction(
      () => this.rootStore.walletStore.basicAsset.balance.available,
      (value, prevValue) => {
        if (Number(value) > Number(prevValue) && prevValue !== null) {
          this.setNotificationType(NOTIFICATION_TYPE.BALANCE_CHANGES);
          this.setBalanceChange({
            ...this.balanceChanges,
            usd: Number(value) - Number(prevValue),
          });
        }
      },
    );
  }

  public setNotificationType(notificationType: NOTIFICATION_TYPE | null) {
    this.notificationType = notificationType;
  }

  public setBalanceChange = (balanceChanges: BALANCE_CHANGES) => {
    this.balanceChanges = balanceChanges;
  };

  public clearBalanceChanges = () => {
    this.balanceChanges = { tokens: 0, usd: 0 };
  };

  public setNotificationMessage = (notification: string) => {
    this.notificationMessage = notification;
  };
}
